import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { isNull } from 'lodash';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { AppState } from '../store/app.reducers';
import { AuthState } from '../store/reducers';
import { retrieveSessionAction } from '../store/actions/auth.actions';
import { slideInAnimation } from '../animations/route-animation';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  animations: [slideInAnimation]
})
export class PagesComponent implements OnInit, OnDestroy {
  public loading = false;
  public sessionSubscription: Subscription;
  private loadingSubscription: Subscription;

  constructor(private store: Store<AppState>) {
    this.sessionSubscription = new Subscription();
  }

  public ngOnInit(): void {
    this.checkUserData();
    this.loadingSubscription = this.store.select('auth').subscribe((authData: AuthState) => {
      setTimeout(() => { this.loading = authData.loading; }, 0);
    });
  }

  public ngOnDestroy(): void {
    this.sessionSubscription.unsubscribe();
    this.loadingSubscription?.unsubscribe();
  }

  public prepareRoute(outlet: RouterOutlet): any {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }

  public checkUserData(): void {
    this.sessionSubscription = this.store.select('auth')
      .pipe(take(1))
      .subscribe((authData: AuthState) => {
        if (isNull(authData.user) && !authData.loading) {
          this.retrieveUserData();
        }
      });
  }

  public retrieveUserData(): void {
    this.store.dispatch(retrieveSessionAction());
  }
}
